import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { IColumnDefinition } from '../../common/models/column-definition';
import { TenancyScheduleTableColumnsHttpService } from '../services/tenancy-schedule-table-columns-http.service';

import * as tenancyScheduleTableColumns from '../actions/tenancy-schedule-table-columns';
import * as tenancyScheduleTable from '../actions/tenancy-schedule-table';

@Injectable()
export class TenancyScheduleTableColumnsEffects {

  constructor(
    private actions$: Actions,
    private tenancyScheduleTableColumnsService: TenancyScheduleTableColumnsHttpService
  ) { }

  
  updateColumnsComplete$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTableColumns.UpdateColumnsComplete>(tenancyScheduleTableColumns.UPDATE_COLUMNS_COMPLETE),
    mergeMap(payload => [
      new tenancyScheduleTable.Load(payload.context, payload.widget),
      new tenancyScheduleTableColumns.Load(payload.widget)
    ])
  ));

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTableColumns.Load>(tenancyScheduleTableColumns.LOAD),
    mergeMap(action => {
      return this.tenancyScheduleTableColumnsService.getTenancyScheduleTableColumns(action.widget.id).pipe(
        map((columns: IColumnDefinition[]) => new tenancyScheduleTableColumns.LoadComplete(columns, action.widget)),
        catchError(err => of(new tenancyScheduleTableColumns.LoadError(err, action.widget)))
      );
    })));

  
  loadAll$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTableColumns.LoadAll>(tenancyScheduleTableColumns.LOAD_ALL),
    mergeMap(action => {
      return this.tenancyScheduleTableColumnsService.getAllTenancyScheduleTableColumns().pipe(
        map((columns: IColumnDefinition[]) => new tenancyScheduleTableColumns.LoadAllComplete(columns)),
        catchError(err => of(new tenancyScheduleTableColumns.LoadAllError(err)))
      );
    })));

  
  updateColumns$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTableColumns.UpdateColumns>(tenancyScheduleTableColumns.UPDATE_COLUMNS),
    mergeMap(action => {
      return this.tenancyScheduleTableColumnsService.putTenancyScheduleTableColumns(action.columnDefinition, action.widget.id).pipe(
        map(() => new tenancyScheduleTableColumns.UpdateColumnsComplete(action.context, action.widget)),
        catchError(err => of(new tenancyScheduleTableColumns.UpdateColumnsError(err)))
      );
    })));

  
  loadDefaults$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTableColumns.ResetToDefault>(tenancyScheduleTableColumns.RESET_TO_DEFAULT),
    mergeMap(action => {
      return this.tenancyScheduleTableColumnsService.setTableDefaultColumns(action.widget.id).pipe(
        map(() => new tenancyScheduleTableColumns.UpdateColumnsComplete(action.context, action.widget)),
        catchError(err => of(new tenancyScheduleTableColumns.UpdateColumnsError(err)))
      );
    })));

  
  reorderColumns$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTableColumns.ReorderColumns>(tenancyScheduleTableColumns.REORDER_COLUMNS),
    mergeMap(action => {
      return this.tenancyScheduleTableColumnsService.reorderTenancyScheduleTableColumns(action.payload, action.widget.id).pipe(
        map(() => new tenancyScheduleTableColumns.ReorderColumnsComplete(action.widget)),
        catchError(err => of(new tenancyScheduleTableColumns.ReorderColumnsError(err)))
      );
    })));

  
  resizeColumns$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<tenancyScheduleTableColumns.ResizeColumns>(tenancyScheduleTableColumns.RESIZE_COLUMNS),
    mergeMap(action => {
      return this.tenancyScheduleTableColumnsService.resizeColumns(action.payload, action.widget.id).pipe(
        map(() => new tenancyScheduleTableColumns.ResizeColumnsComplete(action.widget)),
        catchError(err => of(new tenancyScheduleTableColumns.ResizeColumnsError(err)))
      );
    })));

}

